export default __webpack_public_path__ + "static/favicon-c9c6c6ec060b4b7c8a340e0ed1eface5.ico";